export const isAustralia = (homeCountry: string[] | string): boolean => {
  if (typeof homeCountry === 'string') {
    if (homeCountry === 'AUS') {
      return true;
    }
  } else {
    let isAustralia = (homeCountry as string[])?.filter(
      (code) => code === 'AUS'
    );
    let internationalCountry = (homeCountry as string[])?.filter(
      (code) => code != 'AUS'
    );

    if (isAustralia && internationalCountry) {
      if (isAustralia.length >= 1 && internationalCountry.length >= 1) {
        return true;
      }
    }
  }

  return false;
};
